import styles from "./Skeleton.module.scss";
import cn from "classnames";
import { SkeletonPropsI } from "./Skeleton.props";

export default function Skeleton({ className, ...props }: SkeletonPropsI) {
  return <span className={cn(styles.wrapper, className)} {...props} />;
}
